<template>
  <v-container fluid>
    <v-card flat elevation="0" style="border-radius: 12px">
      <v-col cols="12">
        <v-row class="py-2 pr-2">
          <v-btn icon @click="redirectTo">
            <v-icon large>mdi-chevron-left</v-icon>
          </v-btn>

          <v-text-field
            v-model="searchText"
            hide-details
            background-color="white"
            outlined
            dense
            autofocus
            single-line
            clearable
            @click:clear="clearData()"
            prepend-inner-icon="mdi-magnify"
            :label="$t('searchMissionOrReward')"
            style="border-radius: 10px"
          ></v-text-field>
        </v-row>
      </v-col>
    </v-card>

    <v-row
      v-if="dataItems.length == 0 && searchText.length <= 3"
      justify="center"
      class="mt-4"
    >
      <v-col v-if="search.length > 0" cols="12" sm="7" md="6" lg="5">
        <div class="d-flex align-center justify-center" style="width: 100%">
          <div
            class="d-flex align-center justify-center px-3"
            style="
              width: fit-content;
              height: 32px;
              border-radius: 16px;
              background-color: #ffffffa6;
              border: 2px solid #ffffffcc;
            "
          >
            <p class="mb-0" style="font-weight: bold">
              {{ $t("searchHistory") }}
            </p>
          </div>
        </div>
      </v-col>
      <v-col v-if="search.length > 0" cols="12" sm="7" md="6" lg="5">
        <v-sheet style="border-radius: 12px">
          <div class="px-4">
            <v-chip-group active-class="primary--text" column>
              <v-chip
                v-for="tag in search"
                :key="tag"
                :color="site.color"
                dark
                @click="insertSearch(tag)"
              >
                {{ tag }}
              </v-chip>
            </v-chip-group>
          </div>
        </v-sheet>
      </v-col>
      <v-col v-if="search.length > 0" cols="12" class="d-flex justify-center">
        <v-chip close @click="clearHistory">{{
          $t("removeSearchHistory")
        }}</v-chip>
      </v-col>
    </v-row>
    <div v-else-if="dataItems.length == 0 && searchText.length > 3">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <v-row class="mt-5">
      <v-col
        v-for="(item, index) in dataItems"
        :key="index"
        cols="6"
        sm="4"
        lg="2"
        class="px-4 py-2"
        :class="index % 2 === 0 ? 'pr-2' : 'pl-2'"
      >
        <div>
          <v-card
            class="rounded-lg pa-3 card-container"
            outlined
            elevation="1"
            width="100%"
            style="border: none"
            @click="openDialog(item)"
            :disabled="item.limit_reached"
          >
            <div
              v-if="item.limit_reached"
              class="d-flex justify-center align-center text-center cover-card-disable"
            >
              <div class="label">{{ $t("limitReached") }}</div>
            </div>
            <div
              v-else-if="item.in_period_remind_date"
              class="d-flex justify-center align-center text-center cover-card-disable"
            >
              <div class="label">{{ $t("textComingSoon") }}</div>
            </div>
            <div
              v-else-if="!item.in_period_show_time_selected"
              class="d-flex justify-center align-center cover-card-disable"
            >
              <div class="label">{{ $t("textTimeCannotJoin") }}</div>
            </div>

            <v-img
              :cover="true"
              :aspect-ratio="1"
              width="100%"
              :lazy-src="require('@/assets/images/image.png')"
              :src="item.image_path"
            >
            </v-img>

            <p
              class="title-mission text-start mb-auto text-subtitle-2 black--text"
              style="
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
              "
            >
              {{ item.name }}
            </p>

            <v-row
              class="bottomleft mt-auto mb-0 text-start text-subtitle-2 pl-2 d-flex align-center"
              style="width: 100%"
            >
              <div v-if="item.point_used" class="ma-1 ml-0">
                <PointSymbol
                  v-if="
                    Array.isArray(item.point_used) && item.point_used.length > 0
                  "
                  :type="item.point_used[0].point_type_type"
                  :symbol="item.point_used[0].point_type_symbol"
                  :color="item.point_used[0].point_type_color"
                  :is_display="true"
                  :outlined_box="false"
                  :size="20"
                />
              </div>
              <div v-if="!item.point_used" class="ma-1 ml-0">
                <v-icon v-if="item.use_reward" :color="site.color" size="20"
                  >mdi-gift</v-icon
                >
                <div v-else>
                  <PointSymbol
                    v-if="Array.isArray(item.point) && item.point.length > 0"
                    :type="item.point[0].point_type_type"
                    :symbol="item.point[0].point_type_symbol"
                    :color="item.point[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="20"
                  />
                </div>
              </div>
              <p
                class="mb-0 text-start text-subtitle-2 pl-0 text-truncate"
                style="width: calc(100% - 48px)"
                :style="{ color: site.color }"
              >
                {{ showPoint(item) }}
              </p>
            </v-row>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <!-- dialog detail activity -->
    <DialogDetailMission
      v-if="dialogDetailMission"
      :item="item"
      :keyComponent="keyComponent"
      :dialogDetail="dialogDetailMission"
      :site="site"
      typeActivity="active"
      @close="dialogDetailMission = false"
    />

    <!--dialog detail reward -->
    <dialogDetailReward
      v-if="dialogDetailReward"
      :dialogDetail="dialogDetailReward"
      :item="item"
      :site="site"
      :keyComponent="keyComponent"
      @addFavorite="addFavorite"
      @deleteFavorite="deleteFavorite"
      @redeemRewardFinal="redeemRewardFinal"
      @close="dialogDetailReward = false"
    />

    <!-- Fern: Confirm Redeem Final dialog -->
    <DialogConfirmRedeemFinal
      :dialogConfirmRedeemFinalVisible="dialogConfirmRedeemFinalVisible"
      :site="site"
      :item="item"
      :quantity="quantity"
      @close="closeConfirmDialog()"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import moment from "moment";
import DialogDetailMission from "./activity/dialogDetail.vue";
import dialogDetailReward from "@/components/reward/dialogDetail.vue";
import DialogConfirmRedeemFinal from "@/components/reward/dialogConfirmRedeemFinal.vue";
import PointSymbol from "./point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    DialogDetailMission,
    dialogDetailReward,
    DialogConfirmRedeemFinal,
    PointSymbol,
  },
  data() {
    return {
      dataItems: [],
      searchText: "",
      typeCard: "",
      item: "",
      dialogDetailMission: false,
      dialogDetailReward: false,
      dialogConfirmRedeemFinalVisible: false,
      btn_submit: false,
      keyComponent: 0,
      quantity: null,
    };
  },
  methods: {
    redirectTo() {
      const targetRoute = this.$router.resolve({
        name: "main",
      });
      window.location.href = targetRoute.href;
    },
    // ========== ========== ========== ==========
    clearHistory() {
      this.$store.commit("defaultSystem/SET_SEARCH", []);
    },
    clearData() {
      this.dataItems = [];
      this.searchText = "";
    },
    insertSearch(text) {
      this.searchText = text || "";
    },
    async searchTextDiscovery(text) {
      try {
        const { data } = await Axios.get(
          `/getMissionRewardSearch?search=${text}`
        );
        this.dataItems = data || [];
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: JSON.stringify(error.response.data.message),
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
    openDialog(item) {
      this.typeCard = item.search_type == "mission" ? "activity" : "reward";
      this.keyComponent++;
      this.item = item;
      if (this.typeCard == "activity") {
        this.dialogDetailMission = true;
        this.$store.dispatch(
          "defaultSystem/checkDuplicateSearch",
          this.searchText
        );
      }
      if (this.typeCard == "reward") {
        this.getReward(item);
        this.$store.dispatch(
          "defaultSystem/checkDuplicateSearch",
          this.searchText
        );
      }
    },

    // ========== ========== Reward ========== ==========
    getReward(item) {
      Axios.get(`reward/getReward`, {
        params: {
          reward_id: item.id,
        },
      })
        .then((res) => {
          if (res.data.status == "success") {
            const { data } = res.data;
            this.item = { ...this.item, ...data };
            this.dialogDetailReward = true;
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    confirmRedeem(item) {
      if (item.limit_reached) return;
      this.item = item;
      Axios.get(`reward/getReward`, {
        params: {
          reward_id: item.id,
        },
      })
        .then((res) => {
          if (res.data.status == "success") {
            const { data } = res.data;
            this.item = { ...this.item, ...data };
            this.dialogDetailReward = true;
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    closeConfirmDialog() {
      this.dialogDetailReward = true;
      this.dialogConfirmRedeemFinalVisible = false;
    },
    redeemRewardFinal(quantity) {
      this.quantity = quantity;
      this.dialogDetailReward = false;
      this.dialogConfirmRedeemFinalVisible = true;
    },

    // ========== ========== Favorite ========== ==========
    deleteFavorite() {
      Axios.delete(`reward/deleteFavoriteItem`, {
        data: { reward_id: this.item.id },
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.item.is_fevorite = !this.item.is_fevorite;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    addFavorite() {
      Axios.post(`reward/addFevoriteItem`, {
        reward_id: this.item.id,
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.item.is_fevorite = !this.item.is_fevorite;
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
            });
            Toast.fire({
              icon: "success",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: JSON.stringify(err.response.data.message),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },

    // ========== ========== Map ========== ==========
    showPoint(pararm) {
      let pointDetail = {
        point: 0,
        point_type_name: "",
      };
      if (Array.isArray(pararm.point) && pararm.point.length > 0) {
        pointDetail = pararm.point[0];
      } else if (
        Array.isArray(pararm.point_used) &&
        pararm.point_used.length > 0
      ) {
        pointDetail = pararm.point_used[0];
      }
      if (pararm.use_reward == true) {
        return `${this.$t("rewardPrize")}`;
      } else if (pointDetail.point == 0 || pararm.type == "check-in") {
        return `${this.$t("conditionCoin")}`;
      } else if (Array.isArray(pararm.point) && pararm.point.length > 1) {
        // return `${this.$t("textNumberMore", { number: pararm.point.length })}`;
        return `+${pararm.point.length}`;
      } else {
        const formattedPoint = this.$options.filters.commaPoint(
          pointDetail.point
        );
        return `${formattedPoint} ${pointDetail.point_type_name}`;
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer", "search"]),
  },
  watch: {
    searchText: function (val) {
      this.searchText = val || "";
      if (val && val.length > 2) {
        this.searchTextDiscovery(val);
      } else if (!val) {
        this.dataItems = [];
      }
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}

.container1 {
  position: relative;
}
.btn-close {
  position: absolute;
  margin-bottom: -100px;
  z-index: 888;
  right: 0;
}
.empty {
  opacity: 1;
}
.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
}
</style>
